import { Dispatch } from "react";
import { v4 as uuid } from "uuid";

import createDataContext from "./createDataContext";

export type LockState = {
  targetElements: string[];
  activeElements: string[];
};

export type LockRequest = {
  targetElements?: string[];
  activeElement?: string;
};

type ActionType =
  | {
      type: "lockScroll";
      values: LockRequest;
    }
  | { type: "unlockScroll"; values: LockState };

const reducer = (state: LockState, action: ActionType): LockState => {
  switch (action.type) {
    case "lockScroll":
      return {
        activeElements: [
          ...state.activeElements,
          action.values.activeElement ?? "unknown",
        ],
        targetElements: [
          ...state.targetElements,
          ...(action.values.targetElements ?? []),
        ],
      };
    case "unlockScroll":
      return {
        activeElements: state.activeElements.filter(
          (item) => !action.values.activeElements.includes(item)
        ),
        targetElements: state.targetElements.filter(
          (item) => !action.values.targetElements.includes(item)
        ),
      };
    default:
      return state;
  }
};

const lockScroll = (dispatch: Dispatch<ActionType>) => {
  return (params: LockRequest): string => {
    const activeElement = params.activeElement ?? uuid();
    dispatch({
      type: "lockScroll",
      values: { ...params, activeElement },
    });
    return activeElement;
  };
};

const unlockScroll = (dispatch: Dispatch<ActionType>) => {
  return (params: Partial<LockState>) => {
    dispatch({
      type: "unlockScroll",
      values: { targetElements: [], activeElements: [], ...params },
    });
  };
};

export const {
  useContext: useScrollLockContext,
  Provider: ScrollLockProvider,
} = createDataContext(
  reducer,
  { lockScroll, unlockScroll },
  { activeElements: [], targetElements: ["authenticated_outlet"] }
);
